import { CampaignSnsRequirementSnsType, CampaignSnsRequirementSnsPostType, LanguageType } from '~/generated/graphql'
import { CampaignDesiredLanguageLabel } from '~/lib/types/Campaign'

// SNSタイプ関連（キャンペーン作成・編集用：Xを除外）
export const SNS_TYPES = [
  CampaignSnsRequirementSnsType.Instagram,
  CampaignSnsRequirementSnsType.Tiktok,
] as const

// SNSタイプ関連（表示用：既存キャンペーンのXデータ表示のためTwitterを含む）
export const SNS_TYPES_FOR_DISPLAY = [
  CampaignSnsRequirementSnsType.Instagram,
  CampaignSnsRequirementSnsType.Tiktok,
  CampaignSnsRequirementSnsType.Twitter,
] as const

export type SnsType = (typeof SNS_TYPES)[number]
export type SupportedSnsType = SnsType
export type DisplaySnsType = (typeof SNS_TYPES_FOR_DISPLAY)[number]

export const SNS_TYPE_LABELS: Record<SupportedSnsType, string> = {
  [CampaignSnsRequirementSnsType.Instagram]: 'Instagram',
  [CampaignSnsRequirementSnsType.Tiktok]: 'TikTok',
}

export const SNS_TYPE_LABELS_FOR_DISPLAY: Record<DisplaySnsType, string> = {
  [CampaignSnsRequirementSnsType.Instagram]: 'Instagram',
  [CampaignSnsRequirementSnsType.Tiktok]: 'TikTok',
  [CampaignSnsRequirementSnsType.Twitter]: 'X',
}

// Instagram投稿タイプ関連
export const SNS_POST_TYPE_LIST_ARRAY = [
  CampaignSnsRequirementSnsPostType.InstagramFeed,
  CampaignSnsRequirementSnsPostType.InstagramReel,
  CampaignSnsRequirementSnsPostType.InstagramStories,
] as const

export const SNS_POST_TYPE_LIST_LABELS = {
  [CampaignSnsRequirementSnsPostType.InstagramFeed]: 'フィード',
  [CampaignSnsRequirementSnsPostType.InstagramReel]: 'リール',
  [CampaignSnsRequirementSnsPostType.InstagramStories]: 'ストーリーズ',
}

// タグ関連
export const SUPPORTED_TAG_LANGUAGES = [LanguageType.Japanese, LanguageType.English] as const
export type SupportedTagLanguage = (typeof SUPPORTED_TAG_LANGUAGES)[number]

export const getUnsupportedTagLanguages = () => {
  const allLanguages = Object.values(LanguageType)
  return allLanguages.filter(
    (lang) => !SUPPORTED_TAG_LANGUAGES.includes(lang as (typeof SUPPORTED_TAG_LANGUAGES)[number]),
  )
}

export const getUnsupportedTagLanguageLabels = (desiredLanguages: LanguageType[]) => {
  const allUnsupportedLanguages = getUnsupportedTagLanguages()
  const unsupportedLanguages = desiredLanguages.filter((lang) => allUnsupportedLanguages.includes(lang))
  return unsupportedLanguages.map((lang) => CampaignDesiredLanguageLabel[lang]).join('、')
}

export const getUnsupportedTagLanguageWarning = (desiredLanguages: LanguageType[]) => {
  const labels = getUnsupportedTagLanguageLabels(desiredLanguages)
  return labels ? `※現在、${labels}のハッシュタグの指定はサポートしていません。` : ''
}

export const getSnsTagLimit = (snsType: CampaignSnsRequirementSnsType) => {
  switch (snsType) {
    case CampaignSnsRequirementSnsType.Twitter:
      return 1
    case CampaignSnsRequirementSnsType.Tiktok:
      return 4
    case CampaignSnsRequirementSnsType.Instagram:
    default:
      return 8
  }
}
